import React from 'react';

interface LoadingSkeletonProps {
  type?: 'card' | 'text' | 'chart';
  count?: number;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ type = 'card', count = 1 }) => {
  const shimmerClass = "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-gray-600/20 before:to-transparent";
  
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg shadow-lg overflow-hidden">
            <div className={`h-32 bg-gray-700 ${shimmerClass}`}></div>
            <div className="p-4 space-y-3">
              <div className={`h-5 bg-gray-700 rounded w-3/4 ${shimmerClass}`}></div>
              <div className={`h-4 bg-gray-700 rounded w-1/2 ${shimmerClass}`}></div>
              <div className="space-y-2 pt-2">
                <div className={`h-3 bg-gray-700 rounded w-full ${shimmerClass}`}></div>
                <div className={`h-3 bg-gray-700 rounded w-full ${shimmerClass}`}></div>
                <div className={`h-3 bg-gray-700 rounded w-full ${shimmerClass}`}></div>
              </div>
            </div>
          </div>
        );
      
      case 'text':
        return (
          <div className="space-y-2">
            <div className={`h-4 bg-gray-700 rounded w-3/4 ${shimmerClass}`}></div>
            <div className={`h-4 bg-gray-700 rounded w-1/2 ${shimmerClass}`}></div>
          </div>
        );
      
      case 'chart':
        return (
          <div className={`h-96 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg flex items-center justify-center ${shimmerClass}`}>
            <div className="text-gray-500 text-lg font-medium">Loading chart...</div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <React.Fragment key={idx}>
          {renderSkeleton()}
        </React.Fragment>
      ))}
    </>
  );
};

export default LoadingSkeleton;
